<h2 mat-dialog-title>Potential Negative Balance Confirmation</h2>
<mat-dialog-content class="mat-typography">

    <p>This invoice will have a negative balance after this payment.</p>

    <p>Balance after payment: <span style="color:red;">{{data.balance | currency }}</span></p>
   
  <h4 style="margin-top:25px;">Click Continue to apply this payment</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
